import { render, staticRenderFns } from "./AddressFormModal.vue?vue&type=template&id=55bf010f&scoped=true"
import script from "./AddressFormModal.vue?vue&type=script&lang=js"
export * from "./AddressFormModal.vue?vue&type=script&lang=js"
import style0 from "./AddressFormModal.vue?vue&type=style&index=0&id=55bf010f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_babel-core@7.0.0-bridge.0_@babel+core@7.28._3caa1b14bd3e4846d6b68320ea08bfb3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf010f",
  null
  
)

export default component.exports